import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const ConfirmModalMUI = ({ open, message, onConfirm, onCancel }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onCancel}
      // Força a modal a ter um z-index elevado para que fique acima da modal pai
      sx={{ zIndex: (theme) => theme.zIndex.modal + 300 }}
      >
      <DialogTitle>Confirmação</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">Não</Button>
        <Button onClick={onConfirm} color="primary">Sim</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModalMUI;
